const typography = {
  fontFamily: "'Roboto', 'Times', 'Arial', sans-serif",
  caption: {
    letterSpacing: "0.4px",
  },
};

export default typography;
